<mat-icon [matMenuTriggerFor]="menu"> more_vert </mat-icon>
<mat-menu #menu="matMenu">
  <button (click)="eventAction.emit(data)" mat-menu-item>
    <mat-icon> visibility </mat-icon> Ver
  </button>
  <button
    (click)="eventAction.emit(data)"
    mat-menu-item
    *ngIf="data.status === 'EM ABERTO' || data.status === 'PENDENTE'"
  >
    <mat-icon> edit </mat-icon> Editar
  </button>
  <button
    (click)="eventAction.emit(data)"
    mat-menu-item
    *ngIf="data.status === 'EM ABERTO' || data.status === 'PENDENTE'"
  >
    <mat-icon> close </mat-icon> Excluir
  </button>
</mat-menu>
